import React, { useState, useEffect, useRef } from 'react';
import { Smartphone } from 'lucide-react';
import { useInstallPrompt } from '../hooks/useInstallPrompt';
import '../styles/ProfileDropdown.css';

function ProfileDropdown({ 
  currentUser, 
  onOpenProfile, 
  onOpenNotifications, 
  onOpenAccount,
  onLogout 
}) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const { isInstallable, isInstalled, promptInstall } = useInstallPrompt();

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const handleMenuClick = (action) => {
    setIsOpen(false);
    action();
  };

  return (
    <div className="profile-dropdown" ref={dropdownRef}>
      <button 
        className="profile-trigger"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="profile-trigger-text">
          Welcome, {currentUser?.name || 'User'}
        </span>
        <span className={`profile-trigger-arrow ${isOpen ? 'open' : ''}`}>
          ▼
        </span>
      </button>

      {isOpen && (
        <div className="profile-menu">
          <button 
            className="profile-menu-item"
            onClick={() => handleMenuClick(onOpenProfile)}
          >
            <span className="menu-icon">👤</span>
            <span className="menu-text">My Profile</span>
          </button>

          <button 
            className="profile-menu-item"
            onClick={() => handleMenuClick(onOpenNotifications)}
          >
            <span className="menu-icon">🔔</span>
            <span className="menu-text">Notification Preferences</span>
          </button>

          <div className="profile-menu-divider" />

          <button 
            className="profile-menu-item"
            onClick={() => handleMenuClick(onOpenAccount)}
          >
            <span className="menu-icon">⚙️</span>
            <span className="menu-text">Account Settings</span>
          </button>

          {isInstallable && !isInstalled && (
            <>
              <div className="profile-menu-divider" />
              <button 
                className="profile-menu-item"
                onClick={() => handleMenuClick(promptInstall)}
              >
                <span className="menu-icon"><Smartphone size={16} /></span>
                <span className="menu-text">Add to Home Screen</span>
              </button>
            </>
          )}
        </div>
      )}
    </div>
  );
}

export default ProfileDropdown;
